import { IClientsContract } from 'src/utils/Interfaces/client.interface'
import style from './style.module.scss'
import { ContractItem } from '../ContractItem'

interface Props {
  items: IClientsContract[]
}
export const ContractList = ({ items }: Props) => {
  return (
    <ul className={style.contracts_list}>
      <li className={style.titles}>
        <span>Name</span>
        <span>Status</span>
        <span>Start Date</span>
        <span>End Date</span>
        <span>Goals</span>
        <span>Current Goals</span>
        <span></span>
      </li>
      {items.length > 0 && items.map((item, i) => <ContractItem key={i} item={item} />)}
      {items.length === 0 && <div className={style.no_contracts}>No contracts</div>}
    </ul>
  )
}
